<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_ii"></a><strong>Also by Thom Hartmann</strong></p>
<p class="indenthanging"><em>Unequal Protection: How Corporations Became “People”—and How You Can Fight Back</em></p>
<p class="indenthanging1"><em>Threshold: The Crisis of Western Culture</em></p>
<p class="indenthanging1"><em>Cracking the Code: How to Win Hearts, Change Minds, and Restore America’s Original Vision</em></p>
<p class="indenthanging1"><em>Screwed: The Undeclared War against the Middle Class—and What We Can Do about It</em></p>
<p class="indenthanging1"><em>What Would Jefferson Do?: A Return to Democracy</em></p>
<p class="indenthanging1"><em>The Last Hours of Ancient Sunlight: The Fate of the World and What We Can Do Before It’s Too Late</em></p>
<p class="indenthanging1"><em>Ultimate Sacrifice: John and Robert Kennedy, the Plan for a Coup in Cuba, and the Murder of JFK</em></p>
<p class="indenthanging1"><em>Legacy of Secrecy: The Long Shadow of the JFK Assassination</em></p>
<p class="indenthanging1"><em>We the People: A Call to Take Back America</em></p>
<p class="indenthanging1"><em>Walking Your Blues Away: How to Heal the Mind and Create Emotional Well-being</em></p>
<p class="indenthanging1"><em>Attention Deficit Disorder : A Different Perception</em></p>
<p class="indenthanging1"><em>Thom Hartmann’s Complete Guide to ADHD: Help for Your Family at Home, School and Work</em></p>
<p class="indenthanging1"><em>Healing ADD : Simple Exercises That Will Change Your Daily Life</em></p>
<p class="indenthanging1"><em>The Edison Gene: ADHD and the Gift of the Hunter Child</em></p>
<p class="indenthanging1"><em>ADD Success Stories: A Guide to Fulfillment for Families with Attention Deficit Disorder</em></p>
<p class="indenthanging1"><em>Think Fast: The ADD Experience</em></p>
<p class="indenthanging1"><em>Beyond ADD: Hunting for Reasons in the Past and Present</em></p>
<p class="indenthanging1"><em>ADHD Secrets of Success: Coaching Yourself to Fulfillment in the Business World</em></p>
<p class="indenthanging1"><em>The Prophet’s Way: A Guide to Living in the Now</em></p>
<p class="indenthanging1"><em>The Greatest Spiritual Secret of the Century</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also.vue?024568e2